import { Component,Inject, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiCall } from '@shared/async-services/http/api-call.service';
import { BroadCastServiceService } from '@shared/services/broad-cast-service.service';
import { ToastrService } from 'ngx-toastr';
import { MultiSelectComponent } from '@syncfusion/ej2-angular-dropdowns';
import { CheckBoxComponent } from '@syncfusion/ej2-angular-buttons';
import storageService from '@shared/storage/storageService';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss']
})
export class EditUserComponent implements OnInit {

  public userForm: FormGroup;
  public roles: FormArray;
  public submitted = false;
  file: any;
  data: any[];
  loading: boolean = false;
  organizationList: any;
  userRoles : any;
  selectedRole;
  selectedOrg = '';
  userId :any;
  updateToaster :any;
  assignToaster :any;
  roleToUpdate : any;
  isRole = false;
  isAssignedAccountant = false;
  accountants: any[];

  @ViewChild('checkbox')
  public mulObj: MultiSelectComponent;
  @ViewChild('selectall')
  public checkboxObj: CheckBoxComponent;
  @ViewChild('dropdown')
  public dropdownObj: CheckBoxComponent;
  @ViewChild('select')
  public reorderObj: CheckBoxComponent;
  public mode: string;
  public filterPlaceholder: string;
  public selectedAccountants: any = [];
  public accountantId : any;

  

  public checkFields: Object = { text: 'name', value: 'accountantId' };
  public checkWaterMark: string = 'Select Accountants';
  public popHeight: string = '350px';
  selectedLanguage = "";
  allSpecialties: any[];
  allSpecialization: any[];
  allDepartments: any[];
  departments: any[];
  
  constructor(
    public dialogRef: MatDialogRef<EditUserComponent>,
    public fb: FormBuilder, public auth: ApiCall,
    private toastr: ToastrService,
    private broadCast: BroadCastServiceService,
		public translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public editData: any,) {
    this.userForm = fb.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
      contactNumber: ['', [Validators.required]],
      organizationId: [''],
      roles: [''],
      assignAccountants: [''],
      useCompanyAddress: [true],
      city: [''],
      activitySector: [''],
      activity: [''], 
      legalStatus : [''],
      turnover: [''],
      effective: [''],
      clientOrganization:[''],
      grade : [''],
      department : ['']
    });

  }

  getRole(obj) {
    let temp = [];
    let role_object = this.userRoles.find(role=> role.id == obj );
    temp.push(role_object);
    return temp;
  }

  ngOnInit() {
    this.mode = 'CheckBox';
    this.filterPlaceholder = 'Search accountants';
    this.selectedAccountants = [];
    this.getUserRoles();
    this.getOrganisationList(); 
    this.userForm.setValue({
      firstName: this.editData.firstName ? this.editData.firstName : "",
      lastName: this.editData.lastName ? this.editData.lastName : "",
      email: this.editData.email ? this.editData.email : "",
      contactNumber: this.editData.contactNumber ? this.editData.contactNumber  : "",
      organizationId: this.editData.organizationId ?  this.editData.organizationId : "",
      roles:this.editData.roles[0].id ? this.editData.roles[0].id : "",
      assignAccountants : this.selectedAccountants,
      useCompanyAddress : this.editData.useCompanyAddress ? this.editData.useCompanyAddress : true,
      city: this.editData.city ? this.editData.city : "",
      activitySector : this.editData.activitySector ? this.editData.activitySector : "",
      activity : this.editData.activity ? this.editData.activity : "", 
      legalStatus : this.editData.legalStatus ? this.editData.legalStatus : "",
      turnover : this.editData.turnover ? this.editData.turnover : "",
      effective : this.editData.effective ? this.editData.effective : "",
      clientOrganization: this.editData.clientOrganization ? this.editData.clientOrganization : "",
      grade : this.editData.grade ? this.editData.grade : "",
      department : this.editData.department ? this.editData.department : ""
    });
    this.selectedRole = this.editData.roles[0].id;
    this.selectedOrg = this.editData.organizationId;
    if(this.selectedOrg){
      this.getAccountants();
    }
    this.getAssignAccountant(); 
    this.userForm.get('email').valueChanges.subscribe((event) => {
      this.userForm.get('email').setValue(event.toLowerCase(), { emitEvent: false });
      })
      this.getAllSpecializations();
      this.getAllDepartments();
  }

  setLanguage() {
		this.selectedLanguage = storageService.getItem("language");
		this.translate.use(this.selectedLanguage);
	}

  getAssignAccountant(){
    this.auth.getUserAccountants(this.editData.id).subscribe((res: any) => {
      try {
        let accountantList = res.data;
        accountantList.forEach(accountant => {
          if (accountant != null) {
            this.selectedAccountants.push(accountant.accountantId);
          }
        });
        this.userForm.setValue({
          assignAccountants : this.selectedAccountants
        });
      } catch(e) {
        console.log("Error while assigning accountants :: ",e);
      }
    });
  }

  select(event){
    console.log("Event",event.itemData.id);
  }

  onRemove(event){
    try {
      this.auth.deleteAssignAccountantToClient(this.editData.id,event.itemData.id).subscribe((res:any)=>{
        if(res.status == "SUCCESS"){
          this.toastr.success(res.message, '');
        }else{
          this.toastr.error(res.message, '');
        }
      });
    } catch (error) {
      console.log("Error")
    }
  }

  changeOrg(evt){
      this.selectedOrg=evt.target.value;
      this.getAccountants();
  }
  changeRole(evt){
    this.selectedRole=evt.target.value;
    if(this.editData.roles[0].id === this.selectedRole) {
      this.isRole = true;
    }
  }
  getOrganisationList() {
    this.auth.getOrganisationList().subscribe((res: any) => {
      this.data = res.data;
      this.organizationList = this.data[0];
    })
  }

  get f(): { [key: string]: AbstractControl } {
    return this.userForm.controls;
  }

  getUserRoles() {
    this.auth.getUserRoles().subscribe((res: any) => {
      this.userRoles = res.data;
    })
  }

  getAccountants() {
    try {
      let selectedOrganizationId = this.selectedOrg;
      if (selectedOrganizationId !== "" && selectedOrganizationId !== null) {
        this.auth.getAccountants(selectedOrganizationId).subscribe((response) => {
          let accountantsWithoutCurrentUser = response.data.filter((accountant => accountant.id != this.editData.id));
          this.accountants = this.preparedAccountantData(accountantsWithoutCurrentUser);
        }, (err) => {
          console.log(err);
        });
      }
    } catch (exception) {
      console.error("Error ocurred while getting the accountants");
    }
  }
  preparedAccountantData(accountants){
    accountants.forEach(accountant => {
      let firstName = accountant.firstName ? accountant.firstName : accountant.accountant.firstName;
      let lastName = accountant.lastName ? accountant.lastName : accountant.accountant.lastName;
      accountant.name = firstName + ' ' + lastName;
      accountant.accountantId = accountant.accountantId ? accountant.accountantId : accountant.id;
    });
    return accountants;
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
  updateData(): void {
    try {
      this.submitted = true;
      if (!this.userForm.valid) {
        return;
      }
        this.updateUser();
    } catch {
      this.toastr.error(this.updateToaster, '');

    }
  }

  assignAccountants(assignAccountants){
    if (assignAccountants.length > 0) {
      let accountantObj = this.preparedAssignAccountantRequestObject(assignAccountants);
      this.auth.assignAccountants(this.userId, accountantObj).subscribe((response) => {
        this.dialogRef.close(false);
        this.assignToaster=response.message;
        this.toastr.success(this.assignToaster,'');
      }, (err) => {
        this.toastr.error(this.assignToaster, '');
      });
    } else {
      this.dialogRef.close(false);
    }
  }

  preparedAssignAccountantRequestObject(assignAccountants){
    let accountantArray = [];
    assignAccountants.forEach(id => {
      let accountantObj : any = {};
      accountantObj.accountantId = id;
      accountantArray.push(accountantObj);
    });
    return accountantArray;
  }

  updateUser(){
    this.userForm.value.id=this.editData.id;
    this.loading=true;
    this.userForm.value.roles = this.getRole(this.userForm.value.roles);

    if(this.selectedRole){
      this.userForm.value.roles = this.getRole(this.selectedRole);
    }
    let requestBody = this.prepareEditUserRequestBody(this.userForm.value);
		this.auth.updateSuperAdminUser(requestBody).subscribe((res: any) => {
        if(res.status == "SUCCESS"){
          this.broadCast.sendMessage("getUser");
          this.broadCast.sendMessage('organization'); 
					this.updateToaster=res.message;
          this.userId = res.data.id;
          if(res.data.roles[0].id == 4) {
            let activty = {
              activitySectorName : res.data.activitySector
            }
            this.auth.addActivitySector(activty,this.userId).subscribe(res => {
              if(res.status == 'SUCCESS') {
              }
            });
          }
          if(!this.isRole && !this.isAssignedAccountant){
            this.dialogRef.close(false);
          }
           if(this.isRole){
             this.updateRole();
           }
           if(this.isAssignedAccountant && res.data.roles[0].id == 4){
            this.assignAccountants(this.userForm.value.assignAccountants);
           }
           if(!this.isRole && this.isAssignedAccountant) {
            this.dialogRef.close(false);
           }
           this.translate.get(['SUPER_ADMIN.USERS.ADD_USER.UPDATE_SUCCESS'])
              .subscribe(translations => {
              this.updateToaster = translations['SUPER_ADMIN.USERS.ADD_USER.UPDATE_SUCCESS'];
            });
           this.toastr.success(this.updateToaster,'');
				  }else{
            this.toastr.error(res.message,'');
				  }
		  }, (error) => {
          console.log();
      }, () => {
        this.loading=false;
      })	
  }

  prepareEditUserRequestBody(formValue) {
    try {
      return {
        ...formValue, 
        active: this.editData.active,
        fullName: formValue.firstName + " " + formValue.lastName
      };
    } catch (error) {
      console.error("Error while preparing request body, ", error);
    }
  }

  updateRole(){
    try {
        this.roleToUpdate = this.getRole(this.selectedRole);
        this.auth.updateUserRole(this.editData.id,this.roleToUpdate).subscribe((res: any) => {
            if(res.status == "SUCCESS"){
              this.toastr.success(res.message,'');
              this.dialogRef.close(false);
              this.broadCast.sendMessage("getUser");
                this.broadCast.sendMessage('organization'); 
              }else{
                this.toastr.error(res.message,'');
              }
          })
    } catch (error) { 
    }
  }

  selectionChange(event) {
    this.isAssignedAccountant= true;
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  // alphabetKeyPress(event: any) {
  //   const inputField = event.target as HTMLInputElement;
  //   const pattern = /^[a-zA-Z\s!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~]*$/;
  //   const inputChar = String.fromCharCode(event.charCode);
  //   if (event.keyCode !== 8 && !pattern.test(inputChar)) {
  //     event.preventDefault();
  //   }
  // }
  // onPaste(event: ClipboardEvent) {
  //   const clipboardData = event.clipboardData;
  //   const pastedData = clipboardData.getData('text/plain');
  //   const regex = /[0-9]/g;
  
  //   if (regex.test(pastedData)) {
  //     event.preventDefault(); 
  //   }
  // }

  getAllSpecializations() {
    try {
      this.allSpecialties = [];
      this.allSpecialization = [];
      this.auth.getSpecializations().subscribe((res) => {
        this.allSpecialization = res.data;
          res.data.forEach(element => {
             this.allSpecialties.push(element.specializationType);
          });
        this.translate.get(['CHIEF_ACCOUNTANT.PROFILE_SETTINGS.PRIMARY_DETAILS.SPECIALTY_1', 'CHIEF_ACCOUNTANT.PROFILE_SETTINGS.PRIMARY_DETAILS.SPECIALTY_2', 'CHIEF_ACCOUNTANT.PROFILE_SETTINGS.PRIMARY_DETAILS.SPECIALTY_3', 'CHIEF_ACCOUNTANT.PROFILE_SETTINGS.PRIMARY_DETAILS.SPECIALTY_4', 'CHIEF_ACCOUNTANT.PROFILE_SETTINGS.PRIMARY_DETAILS.SPECIALTY_5','CHIEF_ACCOUNTANT.PROFILE_SETTINGS.PRIMARY_DETAILS.SELECT_SPECIALTY','CHIEF_ACCOUNTANT.PROFILE_SETTINGS.PRIMARY_DETAILS.SEARCH_SPECIALTY'])
          .subscribe(translations => {
            this.checkWaterMark = translations['CHIEF_ACCOUNTANT.PROFILE_SETTINGS.PRIMARY_DETAILS.SELECT_SPECIALTY'];
            this.filterPlaceholder = translations['CHIEF_ACCOUNTANT.PROFILE_SETTINGS.PRIMARY_DETAILS.SEARCH_SPECIALTY'];
        },(err) => {
          console.log(err);
        });

      }, (error) => {
        console.error("Error while getting specialties : ", error);
      });
    } catch (error) {
      console.error("Error : ", error);
    }
  }

  getAllDepartments() {
    try {
      this.allDepartments = [];
      this.departments = [];
      this.auth.getDepartments().subscribe((res) => {
        this.allDepartments = res.data;
          res.data.forEach(element => {
             this.departments.push(element.departmentName);
          });

      }
      , (error) => {
        console.error("Error while getting department : ", error);
      });
    } catch (error) {
      console.error("Error : ", error);
    }
  }
}
